import React, { useState } from 'react';
import Modal from './Modal';
import CustomButton from './CustomButton';
import { CloseMD, CircleWarningFilled } from '../normalizer';

/**
 * Gamification 2026 — Popup (warning / attention dialog)
 *
 * Props:
 *   isOpenValue {boolean}  — initial open state (controlled by parent via conditional render)
 *   onClose     {Function} — optional callback when dismissed
 *   title       {string}   — header title text
 *   children    {node}     — body content
 */
const Popup = ({ isOpenValue, onClose, title, children }) => {
  // Local state so the user can dismiss without the parent needing a callback.
  // The parent controls mounting via conditional render (allowed == false).
  const [isOpen, setIsOpen] = useState(isOpenValue);

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  return (
    <Modal show={isOpen} untoggle={handleClose} extraSmall>
      <div className="gl2026-modal__header">
        <CircleWarningFilled className="gl2026-modal__header-icon" />
        {title && <h4 className="gl2026-modal__title">{title}</h4>}
        <button
          type="button"
          className="gl2026-modal__close"
          onClick={handleClose}
          aria-label="Fechar"
        >
          <CloseMD />
        </button>
      </div>
      <div className="gl2026-modal__body">
        {children}
      </div>
      <div className="gl2026-modal__footer">
        <CustomButton type="button" onClick={handleClose}>OK</CustomButton>
      </div>
    </Modal>
  );
};

export default Popup;